<div
  #tooltip
  class="fms-tooltip fms-tooltip-scrollbar"
  [class.relative]="!this.coordinates"
  [class.fixed]="isParentPositionRelative"
  [class.cursor-pointer]="freezeOnHover && isCopyTextOnHoverClick"
  [class.with-scroll]="hasScroll"
  [style]="popUpPosition"
  (click)="freezeOnHover && isCopyTextOnHoverClick && copyText($event)"
  (wheel)="hasScroll && scrollControl($event)">
  <span *ngIf="title"
        [attr.data-qa]="dataQa + '-title'"
        class="text-[0.78125rem] font-medium"
        [ngClass]="additionalClassTitle">{{title}}</span>
  <span *ngIf="text"
        [attr.data-qa]="dataQa + '-text'"
        class="text-[0.625rem] font-normal"
        [ngClass]="additionalClassText">{{text}}</span>
  <div class="fms-tooltip-body" [class.mt-[0.25rem]]="title || text">
    <!-- Your code is down here-->
    <ng-content></ng-content>
    <!-- Your code is down here-->
  </div>
  <!--
    This div replicates the position (coordinates), width, and height of the component that triggered the tooltip.
    It's used to "freeze" the tooltip in place when the user hovers over it.
    See {@link freezeOnHover} for implementation details.
  -->
  <div
    *ngIf="freezeOnHover && !isParentPositionRelative"
    class="position-abs opacity0 left-1/2 transform -translate-x-1/2"
    [style]="bottomDivPosition">
  </div>
</div>
<!-- Same as previous div, but it is used inside TextWithTooltip component -->
<div
  *ngIf="freezeOnHover && isParentPositionRelative"
  class="position-abs opacity0"
  [style]="bottomDivPosition">
</div>
